import React from 'react';
import { themeColors } from '../helper/themeHelper';

const ThemeColorSelector = ({ themeColor, setThemeColor }) => {
    return (
        <div className="mt-32">
            <h6 className="text-xl mb-16">Theme Colors</h6>
            <div className="row gy-4">
                {Object.keys(themeColors).map((key) => {
                    const colorData = themeColors[key];
                    const className = colorData.className || key;
                    return (
                        <div className="col-xxl-2 col-md-4 col-sm-6" key={key}>
                            <input
                                className="form-check-input payment-gateway-input"
                                name="theme-color"
                                type="radio"
                                id={key}
                                checked={themeColor === key}
                                onChange={() => setThemeColor(key)}
                                hidden={true}
                            />
                            <label
                                htmlFor={key}
                                className={`payment-gateway-label border radius-8 p-8 w-100 ${themeColor === key ? 'border-primary-600' : ''}`}
                            >
                                <span className="d-flex align-items-center gap-2">
                                    <span className="w-50 text-center">
                                        <span className={`h-72-px w-100 bg-${className}-600 radius-4`} />
                                        <span className={`text-${key === 'magenta' ? 'lilac' : 'secondary'}-light text-md fw-semibold mt-8 text-capitalize`}>
                                            {colorData.label}
                                        </span>
                                    </span>
                                    <span className="w-50 text-center">
                                        <span className={`h-72-px w-100 bg-${className}-100 radius-4`} />
                                        <span className="text-secondary-light text-md fw-semibold mt-8">
                                            Focus
                                        </span>
                                    </span>
                                </span>
                            </label>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ThemeColorSelector;
